/**
 * As salas jogáveis, na MESMA forma.
 *
 * Existe porque a partir da segunda sala "onde fica a saída" deixa de ter uma
 * resposta só, e a pergunta é feita em dois lugares que NEVER se falam: o
 * servidor decide a vitória, e o cliente desenha o anel. Com duas leituras
 * diferentes de qual sala está no ar, o jogador veria a saída num canto e
 * venceria em outro.
 *
 * Aqui NEVER entra flag: `gamedata` é DADO (invariante 6), e ler flag daqui faria
 * o mesmo dado responder coisas diferentes conforme o processo. Quem escolhe a
 * sala é quem tem a flag na mão — `apps/server/src/room/room.ts` e
 * `apps/client/src/render/bodies.ts` —, e os dois escolhem pelo mesmo `RoomId`.
 *
 * ⚠️ Enquanto a escolha for FLAG, cliente e servidor podem discordar: um bundle
 * antigo com a flag diferente da do processo desenha a sala errada. É a mesma
 * exposição que a flag `objective` já aceitou, e some no dia em que houver mais
 * de duas salas — aí o `welcome` passa a carregar o `RoomId`, e isso é
 * `PROTOCOL_VERSION` novo. Ver `ADR-0021`.
 */
import { balance } from './balance.js';

export type RoomId = 'proto' | 'level01';

export interface RoomContent {
  readonly bodies: readonly { readonly kind: 'anchor' | 'light' | 'heavy' | 'core'; readonly x: number; readonly z: number }[];
  readonly objective: {
    readonly core: { readonly x: number; readonly z: number };
    readonly exit: { readonly x: number; readonly z: number; readonly radius: number };
  };
  readonly hazards: readonly {
    readonly x: number;
    readonly z: number;
    readonly radius: number;
    readonly push: number;
    readonly maxSpeed: number;
  }[];
}

/**
 * `proto` tem UM perigo e o guarda no singular, porque nasceu quando havia um só.
 * A normalização mora aqui, e NEVER no `balance`: mexer na forma do dado antigo
 * mudaria o diff de `gamedata` no CI sem nada ter mudado de verdade.
 */
export const ROOMS: Readonly<Record<RoomId, RoomContent>> = {
  proto: {
    bodies: balance.protoRoom.bodies,
    objective: balance.protoRoom.objective,
    hazards: [balance.protoRoom.hazard],
  },
  level01: balance.level01,
};

/** A sala que a flag escolheu. Um lugar só para a pergunta, e um `RoomId` só para os dois lados. */
export function roomFor(levelEnabled: boolean): RoomContent {
  return ROOMS[levelEnabled ? 'level01' : 'proto'];
}
